import type { EmailPipelineStatusOption } from '../../../types/features/emailPipeline';
import type { EmailPipelineStoreOption } from '../../../types/features/emailPipeline';
import { normalizeStatus } from '../../../utils/normalizers/statusNormalizers';
export { formatDateForApi } from '../../../utils/formatters/dateFormatters';
export { getStatusChipColor } from '../../../utils/formatters/statusFormatters';

type EmailPipelineStatusTone = 'success' | 'warning' | 'danger' | 'neutral' | 'info';

export const EMAIL_PIPELINE_STATUS_OPTIONS: EmailPipelineStatusOption[] = [
  { value: '', label: 'All' },
  { value: 'success', label: 'Success' },
  { value: 'processed', label: 'Processed' },
  { value: 'pending', label: 'Pending' },
  { value: 'failed', label: 'Failed' },
  { value: 'received', label: 'Received' },
  { value: 'ignored', label: 'Ignored' },
  { value: 'invalid', label: 'Invalid' },
];

export const getStoreLabel = (store: EmailPipelineStoreOption): string =>
  `${store.name || 'Unknown Store'} (${store.store_key || 'N/A'})`;

export const getStoreDisplayName = (storeName?: string | null, storeKey?: string | null): string =>
  storeName || (storeKey ? `Store ${storeKey}` : 'Unknown Store');

export const getEmailPipelineStatusTone = (status?: string | null): EmailPipelineStatusTone => {
  const normalized = normalizeStatus(status);

  if (normalized === 'processed' || normalized === 'success' || normalized === 'active') return 'success';
  if (normalized === 'failed' || normalized === 'error' || normalized === 'invalid' || normalized === 'expired') return 'danger';
  if (normalized === 'pending' || normalized === 'queued') return 'warning';
  if (normalized === 'received') return 'info';

  return 'neutral';
};
